(function () {
  'use strict';
  if (window.vssReels) return;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MAX_PLAYING = canHover ? 4 : 2;

  var visible = new Set();
  var playing = new Set();

  function tryPlay(video) {
    if (playing.size >= MAX_PLAYING) return;
    video.muted = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Media events don't bubble — capture phase keeps the playing set accurate
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (v.matches && v.matches('video[data-vss-reel]')) playing.add(v);
  }, true);

  document.addEventListener('pause', function (e) {
    var v = e.target;
    if (!v.matches || !v.matches('video[data-vss-reel]')) return;
    playing.delete(v);
    // A slot freed up — start the next visible video waiting its turn
    visible.forEach(function (candidate) {
      if (candidate.paused && playing.size < MAX_PLAYING) tryPlay(candidate);
    });
  }, true);

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            visible.add(v);
            tryPlay(v);
          } else {
            visible.delete(v);
            if (!v.paused) v.pause();
          }
        });
      }, { threshold: [0, 0.5] })
    : null;

  function bind(video) {
    if (video.__vssReelBound) return;
    video.__vssReelBound = true;
    video.muted = true;

    var mode = video.getAttribute('data-vss-mode') || 'view';

    if (mode === 'hover' && canHover) {
      var root = video.closest('[data-vss-hover-root]') || video;
      root.addEventListener('mouseenter', function () { tryPlay(video); });
      root.addEventListener('mouseleave', function () {
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      });
      return;
    }

    // View mode (and hover mode on touch devices): in-viewport autoplay.
    // Reduced motion means posters only — never autoplay.
    if (reducedMotion || !observer) return;
    observer.observe(video);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('video[data-vss-reel]').forEach(bind);
  }

  window.vssReels = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Theme editor reloads sections without a page load
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
